<template>
  <v-app>
    <soi-header
      :titulo="titulo"
      :titulo-icon="tituloIcon"
      :total-pacientes-ativos="totalPacientesAtivos"
      :total-pacientes-inativos="totalPacientesInativos"
      :mostrar-tooltip-pacientes="mostrarTooltipPacientes"
      :nome-paciente="nomePaciente"
      :nome-social="nomeSocial"
      :usar-nome-social-como-principal="usarNomeSocialComoPrincipal"
      :dadosAbaConsultaEstaVazio="dadosAbaConsultaEstaVazio"
      :dadosConvenioEstaVazio="dadosConvenioEstaVazio"
      :somenteTipoConsultaPreenchidoNaConsulta="somenteTipoConsultaPreenchidoNaConsulta"
      :mini-sidebar="sidebarMinimizada"
      :atendimento-sem-dados="atendimentoSemDados"
      :abrir-menu-mobile="abrirMenuMobile"
      :eh-mobile="ehMobile"
      @mostrarInformacoes="$emit('mostrarInformacoes')"
      @salvar="$emit('salvar')"
      @finalizar="$emit('finalizar')"
      @cancelar="$emit('cancelar')" />
    <soi-sidebar ref="sidebar" @sidebarMinimizada="atualizarSidebar" @mobile-changed="atualizarEstadoMobile" />
    <v-main :class="['main-content-overlay', { 'sidebar-minimized': sidebarMinimizada }]">
      <v-card v-if="$route.name !== 'Agenda'" :class="$route.name !== 'home' ? 'main-card' : ''">
        <slot />
      </v-card>
      <template v-else>
        <slot />
      </template>
    </v-main>
    <div class="position-fixed bottom-0 ajustado-na-tela" :style="estiloAjustadoNaTela">
      <div class="v-speed-dial v-speed-dial--right v-speed-dial--bottom v-speed-dial--direction-top">
        <div v-if="$store.getters['sugestaoResposta/estaCarregando']" class="text-center">
          <v-progress-circular indeterminate size="20" color="primary"></v-progress-circular>
        </div>
        <soi-modal-feedback v-else-if="deveExibirModal" ref="feedbackModal" @sugestao-enviada="onSugestaoEnviada"
          @modal-dispensado="onModalDispensado" />
      </div>
    </div>
    <slot name="assistencia"></slot>
    <v-footer class="v-footer-overlay" :class="{ 'footer-sidebar-minimized': sidebarMinimizada }">
      <div class="links">
        <ul>
          <li><a href="#">Suporte</a></li>
          <li><a href="#">Ouvidoria</a></li>
          <li><a href="#">Política de Privacidade</a></li>
          <li><a href="#">Termos de Uso</a></li>
        </ul>
      </div>
      <div class="copyright">
        <span>&copy; {{ anoCorrente + ' ' + empresa }}</span>
      </div>
    </v-footer>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'soi-masterpage',
  computed: {
    ...mapGetters('sugestaoResposta', [
      'temCampanhaAtiva',
      'dadosCampanhaAtiva',
      'estaCarregando',
    ]),
    campanhaJaFoiDispensada(): boolean {
      const campanhaAtiva = this.$store.getters['sugestaoResposta/dadosCampanhaAtiva'];

      if (!campanhaAtiva?.id) {
        return false;
      }

      return this.verificarCampanhaFoiDispensada(campanhaAtiva.id);
    },
    deveExibirModal(): boolean {
      const temCampanha = this.$store.getters['sugestaoResposta/temCampanhaAtiva'];
      const campanhaAtiva = this.$store.getters['sugestaoResposta/dadosCampanhaAtiva'];
      const estaCarregando = this.$store.getters['sugestaoResposta/estaCarregando'];

      return temCampanha
        && !estaCarregando
        && !this.modalFeedbackDesabilitado
        && !this.campanhaJaFoiDispensada
        && campanhaAtiva?.id;
    },
    estiloAjustadoNaTela(): { bottom: string } {
      return {
        bottom: this.$route.name === 'home' ? '15.5%' : '7%',
      };
    },
    abrirMenuMobile() {
      return () => {
        if (this.$refs.sidebar) {
          (this.$refs.sidebar as any).abrirMenuMobile();
        }
      };
    },
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    tituloIcon: {
      type: String,
      required: false,
      default: '',
    },
    nomePaciente: {
      type: String,
      required: false,
      default: '',
    },
    nomeSocial: {
      type: String,
      required: false,
      default: '',
    },
    usarNomeSocialComoPrincipal: {
      type: Boolean,
      required: false,
      default: false,
    },
    dadosAbaConsultaEstaVazio: {
      type: Boolean,
      required: false,
      default: false,
    },
    dadosConvenioEstaVazio: {
      type: Boolean,
      required: false,
      default: false,
    },
    somenteTipoConsultaPreenchidoNaConsulta: {
      type: Boolean,
      required: false,
      default: false,
    },
    atendimentoSemDados: {
      type: Boolean,
      required: false,
      default: false,
    },
    totalPacientesAtivos: {
      type: Number,
      required: false,
      default: 0,
    },
    totalPacientesInativos: {
      type: Number,
      required: false,
      default: 0,
    },
    mostrarTooltipPacientes: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    year() {
      this.anoCorrente = new Date().getFullYear();
    },
    temCampanhaAtiva: {
      handler(novoValor, valorAnterior) {
        if (novoValor && !valorAnterior) {
          this.modalFeedbackDesabilitado = false;
        }
      },
      immediate: false,
    },
    dadosCampanhaAtiva: {
      handler(novaCampanha, campanhaAnterior) {
        const novaId = novaCampanha?.id;
        const idAnterior = campanhaAnterior?.id;

        if (novaId && novaId !== idAnterior && !this.verificarCampanhaFoiDispensada(novaId)) {
          this.modalFeedbackDesabilitado = false;
        }
      },
      immediate: false,
    },
  },
  data() {
    return {
      anoCorrente: new Date().getFullYear(),
      empresa: 'Grupo SOITIC',
      sidebarMinimizada: this.$store.state.layout?.sidebarMinimizada ?? false,
      modalFeedbackDesabilitado: false,
      ehMobile: false,
    };
  },
  async mounted() {
    try {
      await (this as any).verificarCampanhaAtiva();
      this.limparDispensasAntigasMasterPage();
      const campanhaAtiva = this.$store.getters['sugestaoResposta/dadosCampanhaAtiva'];

      if (campanhaAtiva?.id && this.verificarCampanhaFoiDispensada(campanhaAtiva.id)) {
        this.modalFeedbackDesabilitado = true;
      }
    } catch (error) {
      console.error('Erro ao verificar campanha ativa no MasterPage:', error);
    }

    if (this.$route.query.feedback
      && this.$route.query.feedback === 'reset') {
      this.resetarValidacaoCampanha(this.$route.query.id
        ? Number(this.$route.query.id)
        : undefined);
    }

    this.$nextTick(() => {
      this.atualizarEstadoMobile();
    });
  },
  methods: {
    ...mapActions('sugestaoResposta', [
      'verificarCampanhaAtiva',
      'resetarEstado',
    ]),
    atualizarSidebar(estado: boolean) {
      this.sidebarMinimizada = estado;
    },
    atualizarEstadoMobile(ehMobile?: boolean) {
      if (ehMobile !== undefined) {
        this.ehMobile = ehMobile;
      } else if (this.$refs.sidebar) {
        this.ehMobile = (this.$refs.sidebar as any).ehMobile || (this.$refs.sidebar as any).isMobile || false;
      }
    },
    onSugestaoEnviada(dados: { comentario: string; timestamp: string; pontuacao?: number; campanhaId?: number }) {
      if (dados.campanhaId) {
        const chave = this.obterChaveDispensaCampanha(dados.campanhaId);
        sessionStorage.setItem(chave, 'true');
      }

      this.modalFeedbackDesabilitado = true;
    },
    onModalDispensado(dados?: { campanhaId?: number }) {
      if (dados?.campanhaId) {
        const chave = this.obterChaveDispensaCampanha(dados.campanhaId);
        sessionStorage.setItem(chave, 'true');
      }

      this.modalFeedbackDesabilitado = true;
    },
    async reverificarCampanhaAtiva() {
      try {
        await (this as any).verificarCampanhaAtiva();
      } catch (error) {
        console.error('Erro ao reverificar campanha ativa:', error);
      }
    },
    reabilitarModalFeedback() {
      this.modalFeedbackDesabilitado = false;
    },
    isModalFeedbackDesabilitado(): boolean {
      return this.modalFeedbackDesabilitado;
    },
    async verificarUsuarioJaRespondeuCampanha(campanhaId: number): Promise<boolean> {
      try {
        const { decode, getToken } = await import('@/utils/Token');
        const { SugestaoRespostaService } = await import('@/services/SugestaoRespostaService');
        const token = getToken();

        if (!token) {
          return false;
        }

        const user = decode(token);

        if (!user?.id) {
          return false;
        }

        const sugestaoRespostaService = new SugestaoRespostaService();
        const respostasUsuario = await sugestaoRespostaService.obterSugestoesRespostasPorUsuarioId(user.id);
        return respostasUsuario.some((resposta) => resposta.sugestaoCampanhaId === campanhaId);
      } catch (error) {
        console.error('Erro ao verificar se usuário já respondeu à campanha:', error);
        return false;
      }
    },
    async deveExibirModalFeedback(): Promise<boolean> {
      const campanhaAtiva = this.$store.getters['sugestaoResposta/dadosCampanhaAtiva'];
      const temCampanha = this.$store.getters['sugestaoResposta/temCampanhaAtiva'];

      if (!temCampanha || !campanhaAtiva?.id || this.modalFeedbackDesabilitado) {
        return false;
      }

      if (this.verificarCampanhaFoiDispensada(campanhaAtiva.id)) {
        return false;
      }

      const jaRespondeu = await this.verificarUsuarioJaRespondeuCampanha(campanhaAtiva.id);

      if (jaRespondeu) {
        const chave = this.obterChaveDispensaCampanha(campanhaAtiva.id);
        sessionStorage.setItem(chave, 'true');
        return false;
      }

      return true;
    },
    obterChaveDispensaCampanha(campanhaId?: number): string {
      if (!campanhaId) {
        const campanha = this.$store.getters['sugestaoResposta/dadosCampanhaAtiva'];
        campanhaId = campanha?.id;
      }

      return campanhaId ? `feedback-modal-dispensado-campanha-${campanhaId}` : 'feedback-modal-dispensado';
    },
    verificarCampanhaFoiDispensada(campanhaId?: number): boolean {
      const chave = this.obterChaveDispensaCampanha(campanhaId);
      return !!sessionStorage.getItem(chave);
    },
    limparDispensasAntigasMasterPage(): void {
      const keys = Object.keys(sessionStorage);
      const feedbackKeys = keys.filter((key) => key.startsWith('feedback-modal-dispensado-campanha-'));

      if (feedbackKeys.length > 10) {
        feedbackKeys.slice(0, feedbackKeys.length - 10).forEach((key) => {
          sessionStorage.removeItem(key);
        });
      }
    },
    resetarValidacaoCampanha(campanhaId?: number): void {
      if (campanhaId) {
        const chave = this.obterChaveDispensaCampanha(campanhaId);
        sessionStorage.removeItem(chave);
      } else {
        const keys = Object.keys(sessionStorage);
        const feedbackKeys = keys.filter((key) => key.startsWith('feedback-modal-dispensado'));
        feedbackKeys.forEach((key) => sessionStorage.removeItem(key));
      }

      this.modalFeedbackDesabilitado = false;
    },
  },
});
</script>

<style>
.v-main,
.main-content-overlay {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  left: 0 !important;
  transition: margin-left 0.3s ease-in-out, padding-left 0.3s ease-in-out;
}

.main-content-overlay.sidebar-minimized {
  margin-left: 114px !important;
  width: calc(100% - 114px) !important;
}

@media (max-width: 959px) {
  .v-main,
  .main-content-overlay {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .main-content-overlay.sidebar-minimized {
    margin-left: 0 !important;
    width: 100% !important;
  }
}

.v-main__wrap {
  width: 100% !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
}

.v-application--is-ltr .v-main {
  padding-left: 0 !important;
}

.v-application--is-ltr .v-main__wrap {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.v-application--is-ltr .v-main--has-permanent-drawer:not(.sidebar-minimized) {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.v-application .v-main:not(.sidebar-minimized) {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.v-application .v-main__wrap {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.main-card {
  padding: 0.75rem 0.75rem 1rem;
  margin: 1.5rem 0.75rem 0.5rem;
  width: calc(100% - 1.5rem);
  max-width: calc(100% - 1.5rem);
}

@media (max-width: 960px) {
  .main-card {
    padding: auto;
    margin: 0.6rem 0.03rem 0.4rem;
    width: 100%;
    max-width: 100%;
  }
}

.v-footer {
  background-color: transparent !important;
  padding: 0.5rem;
  gap: 1rem;
  font-weight: 500;
  font-size: 12px;
  line-height: 1rem;
  display: flex;
  justify-content: space-between;
  margin: 1.875rem 1.875rem 1.875rem;
}

.v-footer-overlay {
  width: 100% !important;
  margin-left: 0 !important;
  margin-bottom: 10px;
}

.v-footer .links {
  padding-left: 320px;
}

.v-footer-overlay.footer-sidebar-minimized .links {
  padding-left: 120px;
}

@media (max-width: 959px) {
  .v-footer .links {
    padding-left: 1.5rem;
  }
}

.v-footer .links ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
}

.v-footer .links ul li a {
  text-decoration: none;
  margin: 0 0.5rem;
  color: var(--especialidade-primary, #2e4b9d) !important;
  transition: color 0.3s ease;
}

.v-footer .links ul li a:hover {
  color: var(--especialidade-secondary, #E3E8F4) !important;
  opacity: 0.8;
}

.bottom-0 {
  position: fixed;
  right: 0;
  bottom: 0;
}

.ajustado-na-tela {
  right: 2.9%;
}

.v-footer .copyright {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.v-footer .copyright span {
  color: var(--especialidade-primary, #2e4b9d) !important;
}

.titulo {
  display: flex;
  align-items: center;
}

.titulo .v-icon {
  margin-right: 0.5rem;
}
</style>
